/**
 * Renders a listbox of checkboxes
 *
 */

import React from 'react';

// Components
import Checkbox from './Checkbox';

const MultiSelect = class MultiSelect extends React.Component {
    constructor() {
        super();

        // Set the initial state
        this.state = {
            scrollable: false,
            selected: []
        }

        // Create refs
        //this.listbox = React.createRef();
        this.listBox = null;
        this.setListBoxRef = element => {
            this.listBox = element;
        }
    }

    componentDidMount() {
        this.handleValue();
    }

    componentDidUpdate(prevProps) {
        const newProps = [...this.props.value];
        if(newProps.length !== prevProps.value.length) {
            this.handleValue();
        }
    }

    /**
     * Handle any preset values
     *
     * @function handleValue
     */
    handleValue = () => {
        const newValue = [...this.props.value];

        if(newValue && Array.isArray(newValue)) {
            const selected = [];

            newValue.forEach(val => {
                selected.push(val);
            });

            this.setState({ selected });
        }
    }

    /**
     * Check if listbox is scrollable
     * (Timeout is necessary because the function may fire before render is completed)
     *
     * @function handleOverflow
     */
    handleOverflow = () => {
        setTimeout(() => {
            const el = this.listBox;

            if(el && el.scrollHeight > el.offsetHeight) {
                this.setState({
                    scrollable: true
                });
            }
        })
    }

    /**
     * Handle selection/deselection of an option
     *
     * @function handleChange
     * @param {Event} e
     */
    handleChange = e => {
        const { checked, value } = e.target;
        const { onChange } = this.props;
        const selected = [...this.state.selected];
        const index = selected.indexOf(value);

        if(!checked && index > -1) {
            selected.splice(index, 1)
        } else if(index === -1) {
            selected.push(value);
        }

        if(onChange) {
            onChange(selected);
        }

        this.setState({
            selected
        });
    }

    render() {
        const {
            className,
            errorMsg,
            disabled,
            helper,
            hideLabel,
            id,
            label,
            options,
            required
        } = this.props;
        const { scrollable, selected } = this.state;

        return (
            <div
                className={`multi-select${
                    className ? ` ${className}` : ''
                }`}
            >
                {(label || helper) &&
                <div className="multi-select__text">
                    {label &&
                    <span
                        className={`${hideLabel ? 'meta' : 'multi-select__lbl hybrid-form__lbl'}${
                            required ? ' lbl-required' : ''
                        }`}
                        id={`${id}-label`}
                    >
                {label}
              </span>
                    }

                    {helper &&
                    <span
                        className="multi-select__hint hybrid-form__hint"
                        id={`${id}-helper`}
                    >
                {helper}
              </span>
                    }
                </div>
                }

                {/* Handle validation if required is true */}
                {required &&
                <input
                    className="input--hidden"
                    data-errormsg={errorMsg}
                    value={selected.length > 0 ? selected.toString() : ''}
                    required
                    type="text"
                />
                }

                <ul
                    aria-labelledby={`${id}-label`}
                    className={`multi-select__options${
                        scrollable ? ' multi-select__options--scrollable' : ''
                    }`}
                    ref={this.setListBoxRef}
                    role="listbox"
                >
                    {options.map(
                        (option, i) =>
                            <li key={i}>
                                <Checkbox
                                    defaultChecked={selected.indexOf(option.value) > -1}
                                    disabled={!!disabled}
                                    id={`${id}-option-${i}`}
                                    label={option.label}
                                    name={`group-${id}`}
                                    onChange={this.handleChange}
                                    value={option.value}
                                />
                            </li>
                    )}
                </ul>

                {this.handleOverflow()}
            </div>
        )
    }
}

export default MultiSelect;



// WEBPACK FOOTER //
// ./src/app/components/Common/MultiSelect.js